import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: (theme, disabled) => ({
    position: 'absolute',
    right: 60,
    top: 10,
    backgroundColor: disabled ? theme.colors.buttons.disabled : theme.colors.primaryColor,
    width: 45,
    height: 45,
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
  }),
})
